import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let AnimatedClockIcon = class AnimatedClockIcon extends Vue {
    isLoading;
};
__decorate([
    Prop({ type: Boolean, required: false })
], AnimatedClockIcon.prototype, "isLoading", void 0);
AnimatedClockIcon = __decorate([
    Component({})
], AnimatedClockIcon);
export default AnimatedClockIcon;
